import React, { useState, useEffect, useContext } from 'react'
import PropTypes from 'prop-types'

// Context
import { ZillowContext } from '../../../../../contexts'

// Component
import {
  TextArea,
  Popup,
  Text,
  FormField,
  Button,
  CurrencyInput,
  If,
} from '../../../..'

// Hooks
import { useValidateListingEvaluationQuery } from '../../../../../hooks/listing/queries'

// styles
import styles from './NoHomeDetailsError.module.scss'

const StreetAddressInput = props => <TextArea {...props} />

const NoHomeDetailsError = ({ onClose }) => {
  const { address, listingPrice, resetAndFetchManualAddress } =
    useContext(ZillowContext)

  const [values, setValues] = useState({
    listingPrice: listingPrice || '',
    streetAddress: address || '',
  })
  const [submitDisabled, setSubmitDisabled] = useState(false)

  useEffect(() => {
    if (values.listingPrice === '' || values.streetAddress === '') {
      setSubmitDisabled(true)
    } else {
      setSubmitDisabled(false)
    }
  }, [values])

  const {
    refetch: validateAddress,
    isError,
    isLoading,
    isSuccess,
  } = useValidateListingEvaluationQuery(
    values.streetAddress,
    values.listingPrice
  )

  useEffect(() => {
    if (!isSuccess) return
    resetAndFetchManualAddress(
      values.streetAddress,
      parseInt(values.listingPrice)
    )
  }, [
    isSuccess,
    resetAndFetchManualAddress,
    values.streetAddress,
    values.listingPrice,
  ])

  const handleChange = event => {
    const {
      target: { name, value },
    } = event

    const newValues = {
      ...values,
      [name]: value,
    }

    setValues(newValues)
  }

  const handleSubmit = e => {
    e.preventDefault()
    validateAddress()
  }

  const addressPlaceholder =
    'Ex: 1248 Commonwealth Ave Mayfield Heights, OH 43202'

  return (
    <Popup onClose={onClose}>
      <div className={styles.homeDetailsErrorContainer}>
        <Text color='white' weight='bold' size='l' align='left'>
          Sorry to ask, but we couldn't find a few home details
        </Text>
        <Text color='heather' align='left' className={styles.subheader}>
          This calibrates our market analysis and your personal buy grade.
        </Text>
        <form onSubmit={handleSubmit}>
          <FormField
            value={values.listingPrice}
            name='listingPrice'
            input={CurrencyInput}
            placeholder='$'
            label='Listing price'
            onChange={handleChange}
            allowNegative={false}
            className={styles.listingPrice}
          />
          <FormField
            value={values.streetAddress}
            name='streetAddress'
            input={StreetAddressInput}
            placeholder={addressPlaceholder}
            label='Street address'
            onChange={handleChange}
            className={styles.streetAddress}
          />
          <Button
            type='submit'
            secondary
            fullWidth
            loading={isLoading}
            disabled={submitDisabled}
          >
            Submit details
          </Button>
        </form>
        <If condition={isError}>
          <Text color='red' className={styles.errorText}>
            There was an issue processing this address. Please try again!
          </Text>
        </If>
      </div>
    </Popup>
  )
}

NoHomeDetailsError.propTypes = {
  onClose: PropTypes.func.isRequired,
}

export default NoHomeDetailsError
